import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import { Box, Button, Stack } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import AccountCard, { MockupStateLinks } from '../components/AccountCard';
import { SUCCESS_SOFT, SUCCESS_TEXT, primaryButtonSx } from '../publicStyles';

const BASE = '/mockup/public/verify-email';

// Proposal for /validate_email?code=…, the page the registration email links to.
export default function PublicVerifyEmailPage() {
    const location = useLocation();
    const failed = new URLSearchParams(location.search).get('state') === 'failed';
    const controls = <MockupStateLinks current={failed ? `${BASE}?state=failed` : BASE} options={[
        { label: 'Verified', to: BASE },
        { label: 'Link not valid', to: `${BASE}?state=failed` },
    ]} />;

    if (failed) {
        return (
            <AccountCard title="We couldn’t verify your email" controls={controls}
                intro="Make sure you opened the whole link from the email. You can still log in and use VerbaSchola while this is sorted out.">
                <Stack spacing={1} sx={{ mt: 3 }}>
                    <Button component={RouterLink} to="/mockup/public/login" sx={{ ...primaryButtonSx, minHeight: 48 }}>Log in</Button>
                    <Button href="mailto:support@verbaschola.com" variant="text">Contact support</Button>
                </Stack>
            </AccountCard>
        );
    }

    return (
        <AccountCard title="Your email is verified" controls={controls}
            intro="Thanks for confirming your email address. You can log in and continue.">
            <Box aria-hidden sx={{ mt: 3, width: 56, height: 56, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: SUCCESS_SOFT, color: SUCCESS_TEXT }}>
                <CheckCircleOutlineRoundedIcon sx={{ fontSize: 32 }} />
            </Box>
            <Button component={RouterLink} to="/mockup/public/login" sx={{ ...primaryButtonSx, minHeight: 48, mt: 3, width: '100%' }}>Log in</Button>
        </AccountCard>
    );
}
